import React from 'react';
import {Grid, Image} from 'semantic-ui-react';

import {makeDBContentImageUrl} from 'utils/DBUtils';

class HomepageHeroSection extends React.Component {

  render() {
    return  <Grid columns={2} celled>
              <Grid.Row>
                <Grid.Column>
                  <Image src={makeDBContentImageUrl('b1c82b07-5ee6-4d6f-aec2-5f12db95dad1')}/>
                </Grid.Column>
                <Grid.Column>
                  Content
                </Grid.Column>
              </Grid.Row>
            </Grid>
  }

}

export default HomepageHeroSection;



// WEBPACK FOOTER //
// ./public/components/homepage-layouts/items/hero-section.jsx